import React, { useEffect, useState } from 'react';

import { Card, Button, Modal, Accordion } from 'react-bootstrap';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageTable from '../../../Shared/PageTable/PageTable';
import Field from '../../../Shared/Wizard/Field/Field';
import StringToIcon from '../../../Shared/StringToIcon/StringToIcon';

function MaintenanceTypes() {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;


    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const [editMaintenanceType, setEditMaintenanceType] = useState({
        name: "",
        icon: "",
        generatorUseMoveout: false,
        generatorUseBathroomTuesday: false,
        generatorUseBathroomWednesday: false,
        generatorUseGivenday: false,
        generatorUseMonday: false,
    } as any);

    const [deleteMaintenanceType, setDeleteMaintenanceType] = useState({
        name: "",
        icon: "",
        generatorUseMoveout: false,
        generatorUseBathroomTuesday: false,
        generatorUseBathroomWednesday: false,
        generatorUseGivenday: false,
        generatorUseMonday: false,
    })

    const setEditMaintenanceName = value => { setEditMaintenanceType(editResource => ({ ...editResource, name: value })); }
    const setEditMaintenanceIcon = value => { setEditMaintenanceType(editResource => ({ ...editResource, icon: value })); }
    const setEditGeneratorUseMoveout = value => { setEditMaintenanceType(editResource => ({ ...editResource, generatorUseMoveout: value })); }
    const setEditGeneratorUseBathroomTuesday = value => { setEditMaintenanceType(editResource => ({ ...editResource, generatorUseBathroomTuesday: value })); }
    const setEditGeneratorUseBathroomWednesday = value => { setEditMaintenanceType(editResource => ({ ...editResource, generatorUseBathroomWednesday: value })); }
    const setEditGeneratorUseGivenday = value => { setEditMaintenanceType(editResource => ({ ...editResource, generatorUseGivenday: value })); }
    const setEditGeneratorUseMonday = value => { setEditMaintenanceType(editResource => ({ ...editResource, generatorUseMonday: value })); }

    const [newName, setNewName] = useState("");
    const [newIcon, setNewIcon] = useState("");
    const [newGeneratorUseMoveout, setNewGeneratorUseMoveout] = useState(false);
    const [newGeneratorUseBathroomTuesday, setNewGeneratorUseBathroomTuesday] = useState(false);
    const [newGeneratorUseBathroomWednesday, setNewGeneratorUseBathroomWednesday] = useState(false);
    const [newGeneratorUseGivenday, setNewGeneratorUseGivenday] = useState(false);
    const [newGeneratorUseMonday, setNewGeneratorUseMonday] = useState(false);

    const [show, setShow] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [updateTable, setUpdateTable] = useState(0);

    function handleShow() {
        setShow(true);
    }
    function handleClose() {
        setShow(false);
        cleanNewForm();
    };

    const handleShowEditModal = (dataLine) => {
        setEditMaintenanceType(dataLine);
        setShowEditModal(true);
    }
    const handleCloseEditModal = () => setShowEditModal(false);

    const handleShowDeleteModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setDeleteMaintenanceType(dataLine);
        setShowDeleteModal(true);
    }
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    function cleanNewForm() {
        setNewName("");
        setNewIcon("");
        setNewGeneratorUseMoveout(false);
        setNewGeneratorUseBathroomTuesday(false);
        setNewGeneratorUseBathroomWednesday(false);
        setNewGeneratorUseGivenday(false);
        setNewGeneratorUseMonday(false);
    };


    function handleCreateMaintenanceType() {
        if (newName == "") { notifyWarning(t("maintenancetypes.toast_empty_name")); return undefined; }
        if (newIcon == "") { notifyWarning(t("maintenancetypes.toast_empty_icon")); return undefined; }
        axios.post(
            "/api/maintenancetypes/",
            {
                name: newName,
                icon: newIcon,
                generatorUseMoveout: newGeneratorUseMoveout,
                generatorUseBathroomTuesday: newGeneratorUseBathroomTuesday,
                generatorUseBathroomWednesday: newGeneratorUseBathroomWednesday,
                generatorUseGivenday: newGeneratorUseGivenday,
                generatorUseMonday: newGeneratorUseMonday
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            cleanNewForm();
            notifySuccess(t("maintenancetypes.toast_created"));
            handleClose();
            setUpdateTable(updateTable + 1);
        });
    };

    function handleEditResourcetype() {
        if (editMaintenanceType["name"] == "") { notifyWarning(t("maintenancetypes.toast_resourcetype_empty_name")); return undefined; };
        axios.put(
            "/api/maintenancetypes/" + editMaintenanceType["_id"],
            {
                name: editMaintenanceType["name"],
                icon: editMaintenanceType["icon"],
                generatorUseMoveout: editMaintenanceType["generatorUseMoveout"],
                generatorUseBathroomTuesday: editMaintenanceType["generatorUseBathroomTuesday"],
                generatorUseBathroomWednesday: editMaintenanceType["generatorUseBathroomWednesday"],
                generatorUseGivenday: editMaintenanceType["generatorUseGivenday"],
                generatorUseMonday: editMaintenanceType["generatorUseMonday"]
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            handleCloseEditModal();
            setUpdateTable(updateTable + 1);
            notifySuccess(t("maintenancetypes.toast_updated"))
        });
    };

    function handleDeleteResourcetype() {
        axios.delete(
            "/api/maintenancetypes/" + deleteMaintenanceType["_id"],
            {},
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {

            if (res.status != undefined && res.status === 200) {
                notifySuccess(t("maintenancetypes.toast_deleted"));
                setUpdateTable(updateTable + 1);
            } else {
                notifyWarning(t("maintenancetypes.toast_error"))
            }
            handleCloseDeleteModal();
        })
            .catch((error) => {
                if (error.response.status === 409) {
                    notifyWarning(t("maintenancetypes.toast_in_use"))
                }
                handleCloseDeleteModal();
            });
    };


    useEffect(() => {
        if (auth.user["userdata"] == undefined) { window.location.href = "/login"; }
    }, []);

    const pageTableFields = {
        showFields: [
            { label: t("maintenancetypes.name"), field: "name" },
            {
                label: t("maintenancetypes.icon"), override: (item) => {
                    return (<StringToIcon icon={item} ></StringToIcon>)
                }
            }
        ]
    }


    return (
        <>

            <Card>
                <Accordion.Toggle className="clickable" as={Card.Header} eventKey="2">
                    <h4 className="header-title">{t("maintenancetypes.page_name")}</h4>
                    <p>{t("maintenancetypes.page_description")}</p>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="2">
                    <Card.Body>
                        <Button className="newresourcetypeBtn" onClick={handleShow}>{t("maintenancetypes.new")}</Button>
                        <br />
                        <PageTable
                            dataUrl={"/api/maintenancetypes/getAllPaged/"}
                            options={pageTableFields}
                            dataAfter={(dataLine) => <Button onClick={(evt) => handleShowDeleteModal(dataLine, evt)}>{t("maintenancetypes.delete")}</Button>}
                            onLineClick={handleShowEditModal}
                            hidePagination={false}
                            hidePagesize={false}
                            hideFilter={false}
                            updateTable={updateTable}
                            hover={true}
                        />
                    </Card.Body>
                </Accordion.Collapse>
            </Card>

            {/* Creating modal */}
            <Modal show={show} onHide={handleClose} >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("maintenancetypes.new_title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Field
                        type="input"
                        title={t("maintenancetypes.new_name")}
                        value={newName}
                        onChange={value => setNewName(value)}
                        placeholder={t("maintenancetypes.new_name")}
                    ></Field>
                    <Field
                        type="icon"
                        title={t("maintenancetypes.new_icon")}
                        value={newIcon}
                        options={{
                            selectText: t("maintenancetypes.click_to_select_icon")
                        }}
                        onChange={value => {
                            setNewIcon(value.icon)
                        }}
                    ></Field>
                    <Field
                        type="checkbox"
                        title={t("maintenancetypes.new_generatortype_moveout")}
                        value={newGeneratorUseMoveout}
                        onChange={value => {
                            setNewGeneratorUseMoveout(value)
                        }}
                    ></Field>
                    <Field
                        type="checkbox"
                        title={t("maintenancetypes.new_generatortype_bathroomtuesday")}
                        value={newGeneratorUseBathroomTuesday}
                        onChange={value => {
                            setNewGeneratorUseBathroomTuesday(value)
                        }}
                    ></Field>
                    <Field
                        type="checkbox"
                        title={t("maintenancetypes.new_generatortype_bathroomwednesday")}
                        value={newGeneratorUseBathroomWednesday}
                        onChange={value => {
                            setNewGeneratorUseBathroomWednesday(value)
                        }}
                    ></Field>
                    <Field
                        type="checkbox"
                        title={t("maintenancetypes.new_generatortype_givenday")}
                        value={newGeneratorUseGivenday}
                        onChange={value => {
                            setNewGeneratorUseGivenday(value)
                        }}
                    ></Field>
                    <Field
                        type="checkbox"
                        title={t("maintenancetypes.new_generatortype_monday")}
                        value={newGeneratorUseMonday}
                        onChange={value => {
                            setNewGeneratorUseMonday(value)
                        }}
                    ></Field>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClose}>
                        {t("maintenancetypes.cancel_without_save")}
                    </Button>
                    <Button onClick={handleCreateMaintenanceType}>
                        {t("maintenancetypes.save")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Editing modal */}
            <Modal show={showEditModal} onHide={handleCloseEditModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("maintenancetypes.edit")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Field
                        type="input"
                        title={t("maintenancetypes.new_name")}
                        value={editMaintenanceType["name"]}
                        onChange={val => setEditMaintenanceName(val)}
                    ></Field>
                    <Field
                        type="icon"
                        title={t("maintenancetypes.new_icon")}
                        value={editMaintenanceType["icon"]}
                        onChange={value => {
                            setEditMaintenanceIcon(value.icon)
                        }}
                    ></Field>
                    <Field
                        type="checkbox"
                        title={t("maintenancetypes.new_generatortype_moveout")}
                        value={editMaintenanceType["generatorUseMoveout"]}
                        onChange={value => {
                            setEditGeneratorUseMoveout(value)
                        }}
                    ></Field>
                    <Field
                        type="checkbox"
                        title={t("maintenancetypes.new_generatortype_bathroomtuesday")}
                        value={editMaintenanceType["generatorUseBathroomTuesday"]}
                        onChange={value => {
                            setEditGeneratorUseBathroomTuesday(value)
                        }}
                    ></Field>
                    <Field
                        type="checkbox"
                        title={t("maintenancetypes.new_generatortype_bathroomwednesday")}
                        value={editMaintenanceType["generatorUseBathroomWednesday"]}
                        onChange={value => {
                            setEditGeneratorUseBathroomWednesday(value)
                        }}
                    ></Field>
                    <Field
                        type="checkbox"
                        title={t("maintenancetypes.new_generatortype_givenday")}
                        value={editMaintenanceType["generatorUseGivenday"]}
                        onChange={value => {
                            setEditGeneratorUseGivenday(value)
                        }}
                    ></Field>
                    <Field
                        type="checkbox"
                        title={t("maintenancetypes.new_generatortype_monday")}
                        value={editMaintenanceType["generatorUseMonday"]}
                        onChange={value => {
                            setEditGeneratorUseMonday(value)
                        }}
                    ></Field>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseEditModal}>
                        {t("maintenancetypes.cancel_without_save")}
                    </Button>
                    <Button onClick={handleEditResourcetype}>
                        {t("maintenancetypes.save")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Modal */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("maintenancetypes.delete")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("maintenancetypes.delete_info")}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseDeleteModal}>
                        {t("maintenancetypes.cancel_without_save")}
                    </Button>
                    <Button onClick={handleDeleteResourcetype}>
                        {t("maintenancetypes.delete")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default MaintenanceTypes;